"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionWithTextfieldRequiredSchema = exports.default = void 0;
var QuestionWithTextfield_1 = require("./QuestionWithTextfield");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(QuestionWithTextfield_1).default; } });
Object.defineProperty(exports, "QuestionWithTextfieldRequiredSchema", { enumerable: true, get: function () { return QuestionWithTextfield_1.QuestionWithTextfieldRequiredSchema; } });
//# sourceMappingURL=index.js.map